import React from 'react';
import { ChevronRightIcon } from '@billda/design-system';
import { SearchableNavItem } from '../utils/navigationSearch';

interface CommandPaletteResultItemProps {
  item: SearchableNavItem;
  isSelected: boolean;
  onClick: () => void;
  onMouseEnter: () => void;
}

export const CommandPaletteResultItem: React.FC<
  CommandPaletteResultItemProps
> = ({ item, isSelected, onClick, onMouseEnter }) => {
  const IconComponent = item.icon;

  return (
    <li
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      data-testid={`command-palette-item-${item.text.toLowerCase().replace(/\s+/g, '-')}`}
      className={`mb-0.5 flex h-14 cursor-pointer list-none items-center rounded-lg px-4 transition-colors duration-150 ${
        isSelected
          ? 'bg-surface-primary-soft'
          : 'bg-transparent hover:bg-surface-raised'
      }`}
    >
      {/* Icon */}
      <span
        className={`flex min-w-10 items-center ${
          isSelected ? 'text-content-accent' : 'text-content-secondary'
        }`}
      >
        <IconComponent aria-hidden="true" className="size-6" />
      </span>

      {/* Text content */}
      <span className="min-w-0 flex-1">
        <span className="block text-[15px] font-medium text-content-primary">
          {item.text}
        </span>
        {item.parent && (
          <span className="block text-[13px] text-content-secondary">
            {item.parent}
          </span>
        )}
      </span>

      {/* Right arrow indicator */}
      <ChevronRightIcon
        aria-hidden="true"
        className={`size-5 transition-opacity duration-150 ${
          isSelected
            ? 'text-content-accent opacity-100'
            : 'text-content-disabled opacity-0'
        }`}
      />
    </li>
  );
};
